<template>
  <el-dialog title="提示" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <div class="tip-box flexs"><i class="el-icon-warning"></i>是否确认同意申请<span v-if="applyCustomerPO && applyCustomerPO.cityCompanyName">（{{applyCustomerPO.cityCompanyName}}）</span></div>
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="168px">
      <!-- <el-form-item label="收款银行" prop="bankNum" class="width100">
        <el-select v-model="form.bankNum" placeholder="请选择收款银行">
          <el-option :label="item.bankName" :value="item.bankName" filterable v-for="(item,index) in sectionList" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="付款凭证：" prop="payVoucherUrl" class="width100">
        <div class="upload-box flexs">
          <div class="upload-img">
            <!-- <el-upload :action="uploadUrl" list-type="picture-card" :multiple="false" limit="3"
              :on-success="handleSuccess" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload> -->
            <el-image style="width: 78px; height: 78px;margin:0 5px 35px 0" :src="item.payImg" :preview-src-list="[item.payImg]" v-for="item in form.payOrderNums" :key="item.id"></el-image>
          </div>
          <div class="upload-input">
            <div class="item" v-for="(item,index) in form.payOrderNums" :key="index">
              <div class="flexs">
                <el-button type="primary" @click="getOcrTest(index)" v-if="!item.ocrContent" style="width: 120px;">通过OCR提取文字</el-button>
                <el-popover v-else placement="top-start" title="" width="400" trigger="hover" :content="item.ocrContent">
                  <el-button slot="reference">查看OCR提取的信息</el-button>
                </el-popover>
                <div class="sp-col oper-icon" style="margin-left: 10px;">
                  <el-button type="primary" @click="handleAddItem(item)" size="small">复制凭证截图</el-button>
                  <el-button type="danger" @click="handleDeleteItem(item,index)" size="small">删除</el-button>
                </div>
              </div>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'payOrderNums.' + index + '.payBank'" :rules="{ required: true, message: '请选择收款银行', trigger: 'change' }" class="cus-sty">
                  <el-select v-model="item.payBank" placeholder="请选择银行(用于推送收款凭证)" filterable clearable>
                    <el-option :label="it.bankName" :value="it.bankName" v-for="(it,idx) in visibleBankOptions" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
                <el-button type="text" @click="toggleBankFilter" style="margin-left: 6px;">
                  {{ showAllBanks ? '按城市过滤' : '显示全部' }}
                </el-button>
                <el-form-item :prop="'payOrderNums.' + index + '.payNum'" :rules="{ required: true, message: '请输入支付单号', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payNum" placeholder="请输入支付单号"></el-input>
                </el-form-item>
              </div>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'payOrderNums.' + index + '.payMoney'" :rules="{ required: true, message: '请输入付款金额', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payMoney" placeholder="请输入付款金额"></el-input>
                </el-form-item>
                <el-form-item :prop="'payOrderNums.' + index + '.payTime'" :rules="{ required: true, message: '请选择付款日期', trigger: 'change' }" class="cus-sty">
                  <el-date-picker v-model="item.payTime" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="付款日期"></el-date-picker>
                </el-form-item>

              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="充值赠送金额" prop="upgradeGiftAmount" class="width100">
        <el-input v-model="form.upgradeGiftAmount" placeholder="请输入充值赠送金额"></el-input>
      </el-form-item>
      <!-- <el-form-item label="推送学费账户入账凭证" prop="bankNum" class="width100">
        <el-select v-model="form.bankNum" placeholder="请选择推送学费账户入账凭证" filterable clearable>
          <el-option :label="item.configName" :value="item.configKey" v-for="(item,index) in reasonOptions" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import userApi from '@/api/sys/user'
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import customerRegistrationApi from '@/api/cust/customerRegistration'
import customerRegistrationPayApi from '@/api/cust/customerRegistrationPay'
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
function initFormBean() {
  const formBean = {
    bankNum: '',
    upgradeGiftAmount: null,
    payOrderNums: []
  }
  return formBean
}

export default {
  //popType 0:新增 1:编辑 2:修改身份
  props: {
    sectionList: Array,
    popType: Number
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      isLoading: false,
      formRules: {
        // bankNum: [{
        //   required: true,
        //   message: '请选择推送学费账户入账凭证',
        //   trigger: 'change'
        // }],
      },
      uploadImgs: [],
      id: '',
      customerPO: null,
      applyCustomerPO: null,
      showAllBanks: false, // 是否显示全部银行，false表示按城市过滤
      reasonOptions: [] // 原因选项列表
    }
  },
  computed: {
    filteredSectionList() {
      // 仅显示已启用的银行
      if (!this.sectionList) {
        return []
      }
      const enabled = this.sectionList.filter(it => String(it.isEnable) === '1')
      // 仅按城市公司ID进行过滤（银行 cityId 与 客户 cityCompanyId 匹配）
      const selectedCityCompanyId = this.applyCustomerPO && this.applyCustomerPO.cityCompanyId
      if (selectedCityCompanyId !== undefined && selectedCityCompanyId !== null && selectedCityCompanyId !== '') {
        const ccIdNum = Number(selectedCityCompanyId)
        return enabled.filter(it => Number(it.cityId) === ccIdNum)
      }
      return enabled
    },
    visibleBankOptions() {
      // 根据 showAllBanks 状态返回对应的银行列表
      // true: 显示全部已启用银行，false: 显示按城市过滤后的已启用银行
      const enabled = (this.sectionList || []).filter(it => String(it.isEnable) === '1')
      return this.showAllBanks ? enabled : this.filteredSectionList
    }
  },
  created() {
    this.getReasonOption()
  },
  methods: {
    /**
     * 切换银行过滤模式
     * 在"按城市过滤"和"显示全部"之间切换
     */
    toggleBankFilter() {
      this.showAllBanks = !this.showAllBanks
    },
    handleBlur() {
      let newPayOrderNums = JSON.parse(JSON.stringify(this.form.payOrderNums))
      newPayOrderNums.forEach(i => {
        i.state = 1
        i.dataType = 0
        delete i.createdBy
        delete i.createdTime
      })
      customerRegistrationApi.setPayNum(newPayOrderNums).then(res => {
        if (res.code === '0') {
          this.submit()
        }
        // if (res.code != '0') {
        //   item.ocrContent = ''
        //   this.$set(this.payOrderNums, index, item)
        // }
      }).catch(res => {
        this.isLoading = false
      })
    },
    /**
     * 识别支付单号
     */
    getOcrTest(index) {
      // console.log('-----------');
      return rechargeRecordApi.accurateOCR({ imageUrl: this.form.payOrderNums[index].payImg })
        .then(res => {
          this.form.payOrderNums[index].ocrContent = res.data
        })
    },
    resetForm() {
      this.form = initFormBean()
      this.uploadImgs = []
      this.applyCustomerPO = null
      this.customerPO = null
      this.showAllBanks = false // 重置为按城市过滤模式
    },
    /**
     * 获取原因选项列表
     */
    getReasonOption() {
      sysGiftAccountReasonApi.findOption().then(({ data }) => {
        if (data) {
          this.reasonOptions = data
        }
      })
    },
    handleCreate(row) {
      console.log('row: ', row);
      this.id = row.id
      this.resetForm()
      this.formVisible = true
      // 保存 applyCustomerPO 以便过滤银行列表；同时保持 customerPO 兼容显示
      this.applyCustomerPO = row.applyCustomerPO || null
      this.customerPO = this.applyCustomerPO
      // 查找默认原因（学费赠送入账）
      let findReason = this.reasonOptions.find(i => i.configName == '学费赠送入账')
      if (findReason) {
        this.form.bankNum = findReason.configKey
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.form.payOrderNums = row.payPOList
        this.$set(this.form, 'upgradeGiftAmount', row.upgradeGiftAmount)
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          this.handleBlur()
        }
      });
    },
    submit() {
      // 如果bankNum为空，从payOrderNums中获取第一个payBank值
      let bankNum = this.form.bankNum
      if (!bankNum && this.form.payOrderNums && this.form.payOrderNums.length > 0) {
        const firstPayBank = this.form.payOrderNums.find(item => item.payBank)
        if (firstPayBank && firstPayBank.payBank) {
          bankNum = firstPayBank.payBank
        }
      }
      let query = { bankNum: bankNum, state: 1, id: this.id, upgradeGiftAmount: this.form.upgradeGiftAmount }
      customerRegistrationApi.agreeOrReject(query).then((data) => {
        this.postCallback(data)
      }).catch(res => {
        this.isLoading = false
      });
    },
    handleAddItem(item) {
      this.$confirm('确认复制当前凭证信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用接口获取数据
        customerRegistrationPayApi.create({ state: 0, payImg: item.payImg, registrationId: item.registrationId, dataType: item.dataType }).then(res => {
          if (res.code === '0') {
            let obj = res.data;
            obj.payBank = ""
            obj.payMoney = ""
            obj.payTime = ""
            this.form.payOrderNums.push(obj)
            this.$message.success('复制成功')
          }
        })
      }).catch(() => {
        this.$message.info('已取消复制')
      })
    },
    handleDeleteItem(item, index) {
      this.$confirm('确认删除该凭证信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除接口
        customerRegistrationPayApi.deleteById(item.id).then(res => {
          if (res.code === '0') {
            this.form.payOrderNums.splice(index, 1)
            this.$message.success('删除成功')
          }
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
.cus-sty {
  width: 220px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.tip-box {
  margin-bottom: 20px;

  i {
    font-size: 24px;
    margin-right: 10px;
    color: #e6a23c;
  }
}
.upload-box {
  align-items: flex-start;
  .upload-img {
    width: 80px;
    margin-right: 10px;
  }
  .upload-input {
    width: calc(100% - 80px);
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      margin-bottom: 18px;
    }
  }
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-upload-list__item,
::v-deep .el-upload--picture-card {
  width: 70px;
  height: 70px;
  line-height: 75px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>
